// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6452":"62615052","6850":"770c63b9"}[chunkId] + ".chunk.css";
};